module.exports = __webpack_public_path__ + "img/蒋红红.3e005d07.jpg";